const specialCharacters = [
  { id: 'acute', desc: 'acute accent' },
  { id: 'amp', desc: 'ampersand' },
  { id: 'brvbar', desc: 'broken vertical bar' },
  { id: 'bull', desc: 'bullet' },
  { id: 'cedil', desc: 'cedilla' },
  { id: 'cent', desc: 'cent' },
  { id: 'copy', desc: 'copyright' },
  { id: 'deg', desc: 'degree' },
  { id: 'divide', desc: 'division' },
  { id: 'frac12', desc: 'fraction half' },
  { id: 'frac14', desc: 'fraction quarter' },
  { id: 'frac34', desc: 'fraction three quarters' },
  { id: 'gt', desc: 'greater than' },
  { id: 'iexcl', desc: 'inverted exclamation mark' },
  { id: 'iquest', desc: 'inverted question mark' },
  { id: 'laquo', desc: 'left-pointing double angle quotation mark' },
  { id: 'lt', desc: 'less than' },
  { id: 'macr', desc: 'macron' },
  { id: 'micro', desc: 'micro' },
  { id: 'nbsp', desc: 'non-breaking space' },
  { id: 'not', desc: 'not' },
  { id: 'para', desc: 'paragraph' },
  { id: 'plusmn', desc: 'plus-minus' },
  { id: 'quot', desc: 'quotation mark' },
  { id: 'reg', desc: 'registered' },
  { id: 'raquo', desc: 'right-pointing double angle quotation mark' },
  { id: 'sect', desc: 'section' },
  { id: 'uml', desc: 'umlaut/diaeresis' },
  { id: 'times', desc: 'multiplication' },
  { id: 'trade', desc: 'trade mark' },
  { id: 'euro', desc: 'euro' },
  { id: 'pound', desc: 'pound' },
  { id: 'yen', desc: 'yen' },
  { id: 'bdquo', desc: 'double low-9 quotation mark' },
  { id: 'circ', desc: 'modifier circumflex accent' },
  { id: 'dagger', desc: 'dagger' },
  { id: 'Dagger', desc: 'double dagger' },
  { id: 'hellip', desc: 'horizontal ellipsis' },
  { id: 'ldquo', desc: 'left double quotation mark' },
  { id: 'lsaquo', desc: 'single left-pointing angle quotation mark' },
  { id: 'lsquo', desc: 'left single quotation mark' },
  { id: 'middot', desc: 'middle dot' },
  { id: 'mdash', desc: 'em dash' },
  { id: 'ndash', desc: 'en dash' },
  { id: 'permil', desc: 'per mille' },
  { id: 'rsaquo', desc: 'single right-pointing angle quotation mark' },
  { id: 'rsquo', desc: 'right single quotation mark' },
  { id: 'sbquo', desc: 'single low-9 quotation mark' },
  { id: 'ordf', desc: 'feminine ordinal indicator' },
  { id: 'ordm', desc: 'masculine ordinal indicator' },
  { id: 'rdquo', desc: 'right double quotation mark' },
  { id: 'tilde', desc: 'small tilde' },
  { id: 'hearts', desc: 'black heart' },
  { id: 'diams', desc: 'diamond' }
];

export default specialCharacters;



// WEBPACK FOOTER //
// ./src/javascripts/markdown_editor/markdown_special_characters.es6.js